<template>
  <div
    v-if="isOpen"
    class="fixed left-0 right-0 bottom-0 z-50 p-4"
  >
    <div class="md:flex justify-between items-center max-w-screen-lg mx-auto bg-gray-900 text-white dark:bg-white dark:text-gray-900 p-4 shadow-lg rounded">
      <p class="text-sm md:pr-8">
        <slot />
      </p>
      <div class="mt-4 md:mt-0 md:flex flex-shrink-0">
        <button
          class="flex items-center justify-center px-4 py-2 border border-transparent rounded shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-500 dark:hover:bg-pink-400 focus:outline-none transition-colors"
          type="button"
          aria-label="Close"
          @click="accept"
        >
          {{ $t('Got It') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { get, set } from 'tiny-cookie'
import { supportsLocalStorage } from './Functions'
export default {
	name: 'AppCookieConsent',
	data () {
		return {
			isOpen: false,
			storageName: 'cookieconsent'
		}
	},
	mounted () {
		if (!this.getVisited()) {
			this.isOpen = true
		}
	},
	methods: {
		getVisited () {
			if (supportsLocalStorage()) {
				return localStorage.getItem(this.storageName)
			} else {
				return get(this.storageName)
			}
		},
		setAccepted () {
			if (supportsLocalStorage()) {
				localStorage.setItem(this.storageName, 'accepted')
			} else {
				set(this.storageName, 'accepted')
			}
		},
		setDeclined () {
			if (supportsLocalStorage()) {
				localStorage.setItem(this.storageName, 'declined')
			} else {
				set(this.storageName, 'declined')
			}
		},
		accept () {
			this.setAccepted()
			this.isOpen = false
		},
		decline () {
			this.setDeclined()
			this.isOpen = false
		}
	}
}
</script>
